import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import { createContact, logOutApi, detailContact, updateContact } from '../../../Context/api';
import { teamAddValidation } from '../../../Context/validation';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import Spinner from '../../Spinner/spinner';
import { useNavigate, useParams } from 'react-router-dom';
import NumberInput from '../../../Component/PhoneInput/phoneInput';
import { isValidPhoneNumber } from 'react-phone-number-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
const AddContact = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            getContact()
        }
    }, [])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const getContact = () => {
        axios.post(detailContact(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                addContact.setValues(resp.data.data)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const addContact = useFormik({
        initialValues: {
            name: '',
            email: '',
            mobileNo: '',
        },
        validationSchema: teamAddValidation,
        validate: (values) => {
            const errors = {};
            if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
                delete errors.mobileNo
            } else {
                errors.mobileNo = "Please enter a valid mobile number ";
            }
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                mobileNo: `${values.mobileNo}`,
                email: values.email,
                type: 'ADMIN',
                isGroup: false
            }
            if (id) {
                data.id = id
            }
            // console.log(data, 'PPPPPPPPPPPPPPPPPP')
            // return
            setSpinner(true)
            axios.post(id ? updateContact() : createContact(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                        addContact.resetForm()
                    }, 1000);
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })

        }

    })
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle d-flex align-items-center'>
                            <ChevronLeftIcon sx={{ fontSize: "30px" }} className='cursor' onClick={() => navigate(-1)} /> {id ? 'Edit' : 'Add'}   Contact
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={addContact?.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name*</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={addContact.handleChange}
                                value={addContact.values.name}
                            />
                            {addContact.touched.name && addContact.errors.name ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addContact.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <div className='col-md-6'>
                            <label htmlFor="recipient-name" className="col-form-label">Email*</label>
                            <input type="text" className="form-control" id="recipient-name"
                                name='email'
                                value={addContact.values.email}
                                onChange={addContact.handleChange}
                            />
                            {addContact.touched.email && addContact.errors.email ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addContact.errors.email}
                                </div>
                            ) : null}
                        </div>
                        <div className='col-md-6'>
                            <label htmlFor="recipient-name" className="col-form-label">Mobile Number*</label>
                            <NumberInput
                                width={false}
                                Require={false}
                                Name="mobileNo"
                                HandleChange={addContact}
                                Value={addContact.values.mobileNo}
                            />
                            {addContact.touched.mobileNo && addContact.errors.mobileNo ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addContact.errors.mobileNo}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">{id ? 'Update' : 'Submit'}</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddContact